import { TableComment } from "../../../general/src/TableComment";
import { DataHeader, DataSource, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringPayAdjustment extends Layout {
    dataheaderRecurringPayAdjustment: DataHeader;
    layoutTableComment: TableComment;
    panelEscrowLastUpdated: Panel;
    sourceComments: DataSource;
    sourceDrsRecurDeduct: DataSource;
    switchSubjectToFedMin: Switch;
    tabComments: Tab;
    tabGarnishments: Tab;
    tabGeneral: Tab;
    tabsetRecurringPayAdjustment: Tabset;
    textboxAmount: Textbox;
    textboxCurrency: Textbox;
    textboxCycleId: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductCodecodeType: Textbox;
    textboxDeductEndDate: Textbox;
    textboxDeductStartDate: Textbox;
    textboxDeductionType: Textbox;
    textboxDrsPayeetypeOf: Textbox;
    textboxEscrowBalance: Textbox;
    textboxEscrowLastUpdated: Textbox;
    textboxEscrowThreshold: Textbox;
    textboxFrequency: Textbox;
    textboxGarnishArrears: Textbox;
    textboxGarnishCaseNo: Textbox;
    textboxGarnishCurrent: Textbox;
    textboxGarnishNetAmt: Textbox;
    textboxGarnishOrderNo: Textbox;
    textboxGarnishPercent: Textbox;
    textboxGarnishPriority: Textbox;
    textboxGlid: Textbox;
    textboxLastTaken: Textbox;
    textboxLoanBalance: Textbox;
    textboxOrigLoanAmt: Textbox;
    textboxPayeeId: Textbox;
    textboxPercentage: Textbox;
    textboxReadyToPayFlag: Textbox;
    textboxReferenceNo: Textbox;
    textboxShortDesc: Textbox;
    textboxTotalToDate: Textbox;
    textboxTractorId: Textbox;
    textboxVendorId: Textbox;
}
